import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

import { SystemNotice } from '../../../../services/system-notice.service';
import { RtI18nDirective } from '../runtime-translation.directive';

export interface SystemNoticeSnackbarData {
  notice: SystemNotice;
  onMoreInfo: () => void;
}

/**
 * Snack bar body for a system notice - alert icon, the title and description, an optional
 * More Info button, and an X to dismiss. Opened by SystemNoticeService via openFromComponent;
 * the plain snackBar.open() text API can't render icons.
 */
@Component({
  selector: 'system-notice-snackbar',
  templateUrl: './system-notice-snackbar.component.html',
  styleUrl: './system-notice-snackbar.component.scss',
  imports: [RtI18nDirective]
})
export class SystemNoticeSnackbarComponent {

  public isDismissing = false;

  constructor(
    private snackBarRef: MatSnackBarRef<SystemNoticeSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: SystemNoticeSnackbarData
  ) { }

  /** Dismiss via the ref's action so SystemNoticeService's onAction() still fires and can
   *  record the dismissal and chain to the next notice. */
  public dismiss(): void {
    if (this.isDismissing) { return; }

    this.isDismissing = true;
    this.snackBarRef.dismissWithAction();
  }
}
